import { Tooltip } from "antd";
import {
  CheckCircleFilled,
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
  PauseCircleFilled,
  PauseCircleOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";

export type MenuStatus = "not_live" | "live" | "paused";

export interface MenuSource {
  id: string;
  designId: string;
  name: string;
  thumbUrl?: string;
  publishedAt?: string;
  status: MenuStatus;
}

interface Props {
  menu: MenuSource;
  publishing?: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onGoLive: () => void;
  onPause: () => void;
  onResume: () => void;
}

export function MenuSourceTile({ menu, publishing, onEdit, onDelete, onGoLive, onPause, onResume }: Props) {
  return (
    <div className="menu-tile">
      <div className="menu-tile-media">
        {menu.thumbUrl ? (
          <img src={menu.thumbUrl} alt={menu.name} />
        ) : (
          <div className="menu-tile-thumb-placeholder" />
        )}

        <div className="menu-tile-actions">
          <Tooltip title="Edit">
            <button type="button" className="menu-tile-action" aria-label="Edit" onClick={onEdit}>
              <EditOutlined />
            </button>
          </Tooltip>

          {menu.status === "live" && (
            <Tooltip title="Pause Publishing">
              <button type="button" className="menu-tile-action" aria-label="Pause Publishing" onClick={onPause}>
                <PauseCircleOutlined />
              </button>
            </Tooltip>
          )}

          {menu.status === "paused" && (
            <Tooltip title="Go Live">
              <button
                type="button"
                className="menu-tile-action"
                aria-label="Go Live"
                onClick={onResume}
                disabled={publishing}
              >
                {publishing ? <LoadingOutlined /> : <PlayCircleOutlined />}
              </button>
            </Tooltip>
          )}

          <Tooltip title="Delete">
            <button type="button" className="menu-tile-action" aria-label="Delete" onClick={onDelete}>
              <DeleteOutlined />
            </button>
          </Tooltip>
        </div>
      </div>

      <div className="menu-tile-title">{menu.name}</div>
      {menu.publishedAt && <div className="menu-tile-date">Published {menu.publishedAt}</div>}

      <div className="menu-tile-status">
        {menu.status === "not_live" && (
          <button
            type="button"
            className="menu-status-btn go-live"
            onClick={onGoLive}
            disabled={publishing}
          >
            {publishing ? (
              <>
                <LoadingOutlined />
                Going Live…
              </>
            ) : (
              "Go Live"
            )}
          </button>
        )}
        {menu.status === "live" && (
          <span className="menu-status-pill live">
            <CheckCircleFilled />
            Live
          </span>
        )}
        {menu.status === "paused" && (
          <span className="menu-status-pill paused">
            <PauseCircleFilled />
            Updates Paused
          </span>
        )}
      </div>
    </div>
  );
}
